import { FC, useMemo, useState } from 'react';
import { ExportContext, ExportContextType } from './ExportContext';
import { UseMultipleChartsType } from '@ecosystem/export-utils';

interface ExportContextProviderProps {
  children: React.ReactNode;
}

const ExportContextProvider: FC<ExportContextProviderProps> = ({ children }) => {
  const [chartRefsIsInitialisedStatus, setChartRefsIsInitialisedStatus] = useState<boolean[]>([]);
  const [multipleExportCallbacks, setMultipleExportCallbacks] = useState<UseMultipleChartsType>([]);

  const contextValue: ExportContextType = useMemo(
    () => ({
      chartRefsIsInitialisedStatus,
      setChartRefsIsInitialisedStatus,
      multipleExportCallbacks,
      setMultipleExportCallbacks,
    }),
    [chartRefsIsInitialisedStatus, multipleExportCallbacks],
  );

  return <ExportContext.Provider value={contextValue}>{children}</ExportContext.Provider>;
};

export default ExportContextProvider;
